import React from 'react';
import Colorpicker from '../../Colorpicker/Colorpicker';
import DateHelper from '../../DateHelper/DateHelper';
import numeral from "numeral";

export default class LineAreaChartToolTip extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    return (
      <div className="popover-preview line-chart-tool-tip container" >
        {this.renderPopoverHeader()}
        {this.renderPopoverBody()}
      </div>
    );
  };

  renderPopoverHeader() {
    var xDataDetail = this.props.report_details.data_details.find(detail => detail.chart_element === 'x-axis');

    return (
      <div className="row popover-heading-wrapper">
        <div className="col-xs-11">
          <div className="popover-heading">
            <h3 style={{ padding: '0 15px 5px 0' }}>{DateHelper.printDateToScreen(this.props.toolTipDetails[xDataDetail.data_column_name], this.props.date_format)}</h3>
          </div>
        </div>
        <div className="popover-close-wrapper col-xs-1"><button type="button" className="close" onClick={this.props.closeToolTip}><span aria-hidden="true">x</span><span className="sr-only">Close</span></button></div>
      </div>
    );
  };

  renderPopoverBody() {
    // var yDataDetails = this.props.report_details.data_details.filter(detail => detail.chart_element === 'y-axis');

    var listItems = this.props.yAxixDetails.map((sourceDetail) => {
      var hiddenDetail = this.props.hiddenDetails.length && this.props.hiddenDetails.find(hiddenDataColulumnName => hiddenDataColulumnName == sourceDetail.data_column_name) ? true : false;
      return (
        <li key={sourceDetail.data_column_name} 
          onClick={() => { this.props.onToggleDataSource(sourceDetail.data_column_name) }}
          >
          {<Colorpicker name={sourceDetail.data_column_name} color={sourceDetail.color} read_only={true} width={12} height={12} />}  <p style={hiddenDetail ? { 'display': 'inline-block', marginRight: '20px', textDecoration: 'line-through' } : { 'display': 'inline-block', marginRight: '20px' } }>{sourceDetail.display_name}:</p><p className='pull-right' style={{ 'display': 'inline-block' }}> {this.formatData(this.props.toolTipDetails[sourceDetail.data_column_name], sourceDetail)}</p>
        </li>
      );
    });

    if (this.props.report_details.chart_type.name === 'area_chart') {
      var total = this.props.yAxixDetails.reduce((acc, detail) => {
        return acc += this.props.toolTipDetails[detail.data_column_name]
      }, 0);
    };
    return (
      <div className="row">
        <div className="col-xs-12">
          <ul style={{ listStyleType: 'none', paddingLeft: '0px' }}>
            {listItems}
            {
              this.props.report_details.chart_type.name === 'area_chart'
                ?
                <li>
                  <hr style={{ margin: '5px 0px 5px 0px' }} />
                  <p style={{ 'display': 'inline-block', marginRight: '20px' }}>{I18n.t('total')}:</p>
                  <p className='pull-right' style={{ 'display': 'inline-block' }}> {this.formatData(total, this.props.yAxixDetails[0])}</p>
                </li>
                :
                null
            }
          </ul>
        </div>
      </div>
    )
  };

  formatData(data, detail) {
    if (detail.data_type === 'currency') {
      return this.formatCurrency(data);
    } else if (detail.data_type === 'percent') {
      return `${Math.round(data * 100)}%`;
    } else {
      return data;
    };
  };

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };

  getUniqueSourceDetails(yDetails) {
    return Array.from(new Set(yDetails.map(detail => detail.source_detail.id))).map(sourceId => yDetails.find(detail => detail.source_detail.id === sourceId).source_detail);
  };

};